import { auth } from '../firebaseConfig';
import { signInWithCustomToken } from 'firebase/auth';

// Helper function to get the API URL based on environment
const getApiUrl = () => {
  if (import.meta.env.PROD) {
    return 'https://art-emerge-4744deb5e11a.herokuapp.com/api';
  }
  return 'http://localhost:5051/api';
};

export const shopifyAuth = {
  // Initialize Shopify OAuth flow
  initiateAuth: async (shopDomain) => {
    try {
      const response = await fetch(`${getApiUrl()}/shopify/login?shop=${encodeURIComponent(shopDomain)}`, {
        method: 'GET',
        credentials: 'include'
      });
      
      if (!response.ok) {
        throw new Error('Failed to initiate Shopify auth');
      }
      
      const { authUrl } = await response.json();
      return authUrl;
    } catch (error) {
      console.error('Error initiating Shopify auth:', error);
      throw error;
    }
  },

  // Handle OAuth callback and Firebase custom token
  handleCallback: async (code, shop, state) => {
    try {
      const response = await fetch(
        `${getApiUrl()}/shopify/callback?` +
        `code=${encodeURIComponent(code)}&` +
        `shop=${encodeURIComponent(shop)}&` +
        `state=${encodeURIComponent(state)}`,
        {
          method: 'GET',
          credentials: 'include'
        }
      );

      if (!response.ok) {
        const error = await response.json();
        throw new Error(error.error || 'Failed to complete Shopify auth');
      }

      const { firebaseToken, shopDomain } = await response.json();
      
      // Sign in to Firebase with custom token
      await signInWithCustomToken(auth, firebaseToken);
      
      return { shopDomain };
    } catch (error) {
      console.error('Error handling Shopify callback:', error);
      throw error;
    }
  }
}; 